import React from 'react';
import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ProcessingProgress = ({ 
  progress, 
  status, 
  isComplete, 
  isLoading, 
  completionMessage 
}) => {
  return (
    <>
      {isLoading && (
        <div className="progress-container">
          <div className="progress">
            <div 
              className={`progress-bar ${isComplete ? 'progress-complete' : ''}`}
              role="progressbar" 
              style={{ width: `${progress}%` }}
              aria-valuenow={progress} 
              aria-valuemin="0" 
              aria-valuemax="100"
            />
          </div>
          {status && (
            <div className="progress-status">
              {status}
            </div>
          )}
        </div>
      )}

      {isComplete && !isLoading && (
        <Alert variant="success" className="mb-3">
          <i className="bi bi-check-circle me-2"></i>
          {completionMessage || 'Process completed successfully!'}
        </Alert>
      )}
    </>
  );
};

ProcessingProgress.propTypes = {
  progress: PropTypes.number.isRequired,
  status: PropTypes.string,
  isComplete: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  completionMessage: PropTypes.string
};

ProcessingProgress.defaultProps = {
  status: '',
  completionMessage: 'Process completed successfully!'
};

export default ProcessingProgress;
